import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-translate-button',
  templateUrl: './translate-button.component.html',
  styleUrls: ['./translate-button.component.scss']
})
export class TranslateButtonComponent implements OnInit {
  @Input() canTranslate = false;
  @Input() isTranslated = false;

  @Input() showTranslation = false;
  @Output() showTranslationChange = new EventEmitter<boolean>();

  @Output() translate = new EventEmitter<void>();

  constructor() {}

  ngOnInit(): void {}

  public get labelKey(): string {
    return 'label.' + (this.isTranslated ? (this.showTranslation ? 'showOriginal' : 'showTranslation') : 'translate');
  }

  public onClick(): void {
    if (this.isTranslated) {
      this.showTranslation = !this.showTranslation;
      this.showTranslationChange.emit(this.showTranslation);
    } else {
      this.translate.emit();
    }
  }
}
